import { Type } from '@angular/core';
import { BlockTypeModel } from './block-type.model';
import { DisplayElementModel } from './display-element.model';
import { FormFieldModel } from './form-field.model';


export class CuratorBlockType extends BlockTypeModel {

    disableDropCondition: (blockType: BlockTypeModel) => boolean;

    constructor(
        key: string,
        label: string,
        icon: string,
        twig: string,
        displayElementType: Type<DisplayElementModel>,
        fields: FormFieldModel[],
        componentType?: Type<any>,
        isDashboard?: boolean,
        disableDropCondition?: (blockType: BlockTypeModel) => boolean,
        allowInsideLayout: boolean = false,
        allowInsideCurator: boolean = false
    ) {
        super(
            key,
            label,
            icon,
            twig,
            displayElementType,
            fields,
            componentType,
            isDashboard,
            null,
            allowInsideLayout,
            allowInsideCurator
        );

        this.disableDropCondition = disableDropCondition;
    }

    clone(): CuratorBlockType {
        const clone = super.clone() as CuratorBlockType;
        clone.disableDropCondition = this.disableDropCondition;

        return clone;
    }
}

